import { render, staticRenderFns } from "./Botoes.vue?vue&type=template&id=987d78e8"
import script from "./Botoes.vue?vue&type=script&lang=js"
export * from "./Botoes.vue?vue&type=script&lang=js"
import style0 from "./Botoes.vue?vue&type=style&index=0&id=987d78e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports